import { useCallback, useMemo } from "react";
import { DragDropContext } from "@hello-pangea/dnd";
import { STATUSES } from "@/lib/constants";
import { useData } from "@/context/DataContext";
import { KanbanColumn } from "@/components/crm/KanbanColumn";
import { QuickAdd } from "@/components/crm/QuickAdd";

export default function BoardPage() {
  const { leads, loading, repsById, today, openEditor, moveLead, touchLead } = useData();
  const grouped = useMemo(() => {
    const g = Object.fromEntries(STATUSES.map((s) => [s, []]));
    leads.forEach((l) => g[l.status]?.push(l));
    return g;
  }, [leads]);

  const onDragEnd = useCallback(({ draggableId, source, destination }) => {
    if (destination && destination.droppableId !== source.droppableId) moveLead(draggableId, destination.droppableId);
  }, [moveLead]);

  return (
    <div className="space-y-5" data-testid="board-page">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl">Pipeline</h1>
          <p className="text-sm text-slate-400" data-testid="board-total-count">{leads.length} leads · drag cards or use “Move to”</p>
        </div>
        <QuickAdd />
      </div>
      {loading ? (
        <p className="text-sm text-slate-400" data-testid="board-loading">Loading pipeline…</p>
      ) : (
        <DragDropContext onDragEnd={onDragEnd}>
          <div className="board-scroll" data-testid="kanban-board">
            {STATUSES.map((s) => (
              <KanbanColumn key={s} status={s} leads={grouped[s]} repsById={repsById} today={today}
                onOpen={openEditor} onMove={moveLead} onTouch={touchLead} />
            ))}
          </div>
        </DragDropContext>
      )}
    </div>
  );
}
